var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductsMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(-11.144 -3.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(11.144 3.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M152.133,83.55a2.563,2.563,0,1,0,2.563,2.563A2.566,2.566,0,0,0,152.133,83.55Z",
    transform: "translate(-140.415 -78.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M13.379,29.912A15.256,15.256,0,0,0,15,30a14.986,14.986,0,1,0-2.884-.277m5.1-3.227c2.041-2.4,5.156-6.11,6.324-7.717a3.716,3.716,0,0,0,.834-2.872A2.964,2.964,0,0,0,23.2,14.066c-.386-.3-5.5-4.21-6.566-4.824a2.113,2.113,0,0,0-1.057-.3,2.07,2.07,0,0,0-1.6.818l-.009.012a2,2,0,0,0,.316,2.806c.242.228,2.122,2,3.707,3.489,1.181,1.11.111,2.561-.012,2.72l-.026.033-4.731,7.75a11.7,11.7,0,1,1,3.99-.075Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsMenuIcon);
export default __webpack_public_path__ + "static/media/products_menu_icon.ddfb3cf5.svg";
export { ForwardRef as ReactComponent };